var base = require('settings/security/update-password');

Vue.component('spark-update-password', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/security/update-password.js